import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import FooterNavOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('footerNav', {
  template: require('./template.html'),
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    routeWatch() {
      const r = this.$store.getters.route;
      if (r === 'page-editor') {
        this.unBindPlugin();
        this.bindPlugin();
      }
      return r;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzFooterNav-list' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  components: {
    DropletOptions,
    FooterNavOptions,
    tooltip,
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        perspective: null,
        transform: null,
        subLinkSpacing: null,
        subLinkFontSize: null,
        'letter-spacing': null,
        'text-shadow': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-wide',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  name: 'footerNav',
  props: ['droplet', 'items', 'index'],
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzFooterNav-list',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
      this.unBindPlugin();
      this.bindPlugin();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    $(document).ready(this.bindPlugin);
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    bindPlugin() {
      const $fNav = $(this.$refs.footerNav);
      $fNav.drzFooterNav();
      $fNav.drzAnchorScroll();
    },
    unBindPlugin() {
      const $fNav = $(this.$refs.footerNav);
      if ($fNav.drzFooterNav.destroy) {
        $fNav.drzFooterNav.destroy($fNav);
      }
      if ($fNav.drzAnchorScroll.destroy) {
        $fNav.drzAnchorScroll.destroy($fNav);
      }
    },
    changeBubbleSize(size) {
      this.setBubbleSize = `dropletBubble-${size}`;
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/footer-nav/index.js